// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section-animation {
  transition: all;
  transform: scale(1.5) rotate(-70deg) translate(-50vw, -50vh);
  animation: tilt-in-from-bottom-right 1.7s ease-in-out 1s forwards;
  line-height: 0;
  margin: 0;
  padding: 0;
}

.hero-sub-section-animation {
  transform: translate(0px, 30px);
  opacity: 0;
  transition: all;
  animation: snap-in-from-bottom 1.7s ease-in-out 0.5s forwards;
  line-height: 1.5em;
  margin: 0;
  padding: 0;
}
.qr-sub-section-animation {
  transform: translate(0px, 30px);
  opacity: 0;
  transition: all;
  animation: snap-in-from-bottom 2s ease-in-out 1s forwards;
  line-height: 1.5em;
  margin: 0;
  padding: 0;
}
.shaking-btn-parent:hover .shaking-btn-child {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  perspective: 1000px;
}

.paragraph-animation {
  transition: all;
  transform: translate(0px, 30px);
  opacity: 0;
  animation: snap-in-from-bottom-paragraph 1.7s ease-in-out forwards;
  line-height: 3.5em;
  margin: 0;
  padding: 0;
}

/* Border Animation */

.border-div {
  width: 0%;
  transition: width 1s linear;
}

.border-full > .border-div {
  width: 100%;
}

#mobile-operators-title {
  line-height: 1.28em;
  width: 7.5em;
  transition: width 1s both;
  animation-timeline: view(block 40% 10%);
  animation-name: mobile-operators-section-title-animation-width-adjust;
  animation-fill-mode: both;
  animation-duration: 1s;
  /* Firefox requires this to apply the animation */
  animation-timing-function: linear;
}

/* w-[80%] mobile:w-[50%] tablet:w-[60%] laptop:w-[54%] */
.enterprise-solution-section-title-animation {
  transition: width 1s both;
  animation-timeline: view(block 60% 10%);
  animation-name: enterprise-solution-section-title-animation-width-adjust;
  animation-fill-mode: both;
  animation-duration: 1s;
  /* Firefox requires this to apply the animation */
  animation-timing-function: linear;
}

.software-solution-section-title-animation {
  width: 100%;
  transition: width 1s both;
  animation-timeline: view(block 60% 10%);
  animation-name: software-solution-section-title-animation-width-adjust;
  animation-fill-mode: both;
  animation-duration: 1s;
  /* Firefox requires this to apply the animation */
  animation-timing-function: linear;
}

#payment-solutions-title {
  width: 60%;
  transition: width 1s both;
  animation-timeline: view(block 60% 10%);
  animation-name: payment-solution-section-title-animation-width-adjust;
  animation-fill-mode: both;
  animation-duration: 1s;
  /* Firefox requires this to apply the animation */
  animation-timing-function: linear;
}

/* KEY FRAMES */

@keyframes tilt-in-from-bottom-right {
  0% {
    transform: rotate(70deg) translate(50vw, -50vh);
    opacity: 0;
    scale: 1.5;
  }

  70% {
    opacity: 1;
  }

  100% {
    transform: rotate(0) translate(0, 0);
    opacity: 1;
    scale: 1;
  }
}

@keyframes snap-in-from-bottom {
  0% {
    opacity: 0;
    line-height: 1.5em;
  }

  70% {
    opacity: 1;
  }

  100% {
    transform: rotate(0) translate(0, 0);
    opacity: 1;
    line-height: 1.25em;
  }
}

@keyframes snap-in-from-bottom-paragraph {
  0% {
    opacity: 0;
    line-height: 4.5em;
  }

  70% {
    opacity: 1;
  }

  100% {
    transform: rotate(0) translate(0, 0);
    opacity: 1;
    line-height: 2.5em;
  }
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-5px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(10px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-8px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(8px, 0, 0);
  }
}

@keyframes mobile-operators-section-title-animation-width-adjust {
  0% {
    width: 14.5em;
  }

  100% {
    width: 7.5em;
  }
}

@keyframes enterprise-solution-section-title-animation-width-adjust {
  0% {
    width: 35%;
  }

  100% {
    width: 20%;
  }
}

@keyframes software-solution-section-title-animation-width-adjust {
  0% {
    margin-left: 0px;
    margin-right: 0px;
  }

  100% {
    margin-left: 1.2em;
    margin-right: 1em;
  }
}

@keyframes payment-solution-section-title-animation-width-adjust {
  0% {
    width: 60%;
  }

  100% {
    width: 40%;
  }
}

/* Media query for animations for Desktop Only */
@media screen and (min-width: 1800px) {
}

/* Media query for animations for Laptop only */
@media screen and (min-width: 1440px) and (max-width: 1800px) {
}

/* Media query for animations for Tablet only */
@media screen and (min-width: 960px) and (max-width: 1440px) {
  @keyframes enterprise-solution-section-title-animation-width-adjust {
    0% {
      width: 60%;
    }

    100% {
      width: 39.4%;
    }
  }

  .software-solution-section-title-animation {
    width: 50%;
  }

  @keyframes software-solution-section-title-animation-width-adjust {
    0% {
      width: 50%;
    }

    100% {
      width: 32%;
    }
  }

  #payment-solutions-title {
    width: 60%;
  }

  @keyframes payment-solution-section-title-animation-width-adjust {
    0% {
      width: 60%;
    }

    100% {
      width: 41%;
    }
  }
}

/* Media query for animations for Mobile only */
@media screen and (min-width: 576px) and (max-width: 960px) {
  @keyframes enterprise-solution-section-title-animation-width-adjust {
    0% {
      width: 80%;
    }

    100% {
      width: 49%;
    }
  }

  .software-solution-section-title-animation {
    width: 50%;
  }

  @keyframes software-solution-section-title-animation-width-adjust {
    0% {
      width: 50%;
    }

    100% {
      width: 37%;
    }
  }

  #payment-solutions-title {
    width: 80%;
  }

  @keyframes payment-solution-section-title-animation-width-adjust {
    0% {
      width: 80%;
    }

    100% {
      width: 44%;
    }
  }
}

/* Media query for animations for Smaller screens */
@media screen and (max-width: 576px) {
  @keyframes enterprise-solution-section-title-animation-width-adjust {
    0% {
      width: 80%;
    }

    100% {
      width: 57.5%;
    }
  }

  .software-solution-section-title-animation {
    width: 80%;
  }

  @keyframes software-solution-section-title-animation-width-adjust {
    0% {
      width: 80%;
    }

    100% {
      width: 55%;
    }
  }

  #payment-solutions-title {
    width: 80%;
  }

  @keyframes payment-solution-section-title-animation-width-adjust {
    0% {
      width: 80%;
    }

    100% {
      width: 57%;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/animation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,4DAA4D;EAC5D,iEAAiE;EACjE,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EAEE,+BAA+B;EAC/B,UAAU;EACV,eAAe;EACf,6DAA6D;EAC7D,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EAEE,+BAA+B;EAC/B,UAAU;EACV,eAAe;EACf,yDAAyD;EACzD,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gEAAgE;EAChE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,UAAU;EACV,kEAAkE;EAClE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA,qBAAqB;;AAErB;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,qEAAqE;EACrE,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,uCAAuC;EACvC,wEAAwE;EACxE,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uCAAuC;EACvC,sEAAsE;EACtE,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,uCAAuC;EACvC,qEAAqE;EACrE,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA,eAAe;;AAEf;EACE;IACE,+CAA+C;IAC/C,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;;IAGE,kCAAkC;EACpC;;EAEA;;IAEE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,gDAAgD;AAChD;AACA;;AAEA,+CAA+C;AAC/C;AACA;;AAEA,+CAA+C;AAC/C;EACE;IACE;MACE,UAAU;IACZ;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE;MACE,UAAU;IACZ;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;AACF","sourcesContent":[".hero-section-animation {\n  transition: all;\n  transform: scale(1.5) rotate(-70deg) translate(-50vw, -50vh);\n  animation: tilt-in-from-bottom-right 1.7s ease-in-out 1s forwards;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.hero-sub-section-animation {\n  transition: all;\n  transform: translate(0px, 30px);\n  opacity: 0;\n  transition: all;\n  animation: snap-in-from-bottom 1.7s ease-in-out 0.5s forwards;\n  line-height: 1.5em;\n  margin: 0;\n  padding: 0;\n}\n.qr-sub-section-animation {\n  transition: all;\n  transform: translate(0px, 30px);\n  opacity: 0;\n  transition: all;\n  animation: snap-in-from-bottom 2s ease-in-out 1s forwards;\n  line-height: 1.5em;\n  margin: 0;\n  padding: 0;\n}\n.shaking-btn-parent:hover .shaking-btn-child {\n  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  transform: translate3d(0, 0, 0);\n  perspective: 1000px;\n}\n\n.paragraph-animation {\n  transition: all;\n  transform: translate(0px, 30px);\n  opacity: 0;\n  animation: snap-in-from-bottom-paragraph 1.7s ease-in-out forwards;\n  line-height: 3.5em;\n  margin: 0;\n  padding: 0;\n}\n\n/* Border Animation */\n\n.border-div {\n  width: 0%;\n  transition: width 1s linear;\n}\n\n.border-full > .border-div {\n  width: 100%;\n}\n\n#mobile-operators-title {\n  line-height: 1.28em;\n  width: 7.5em;\n  transition: width 1s both;\n  animation-timeline: view(block 40% 10%);\n  animation-name: mobile-operators-section-title-animation-width-adjust;\n  animation-fill-mode: both;\n  animation-duration: 1s;\n  /* Firefox requires this to apply the animation */\n  animation-timing-function: linear;\n}\n\n/* w-[80%] mobile:w-[50%] tablet:w-[60%] laptop:w-[54%] */\n.enterprise-solution-section-title-animation {\n  transition: width 1s both;\n  animation-timeline: view(block 60% 10%);\n  animation-name: enterprise-solution-section-title-animation-width-adjust;\n  animation-fill-mode: both;\n  animation-duration: 1s;\n  /* Firefox requires this to apply the animation */\n  animation-timing-function: linear;\n}\n\n.software-solution-section-title-animation {\n  width: 100%;\n  transition: width 1s both;\n  animation-timeline: view(block 60% 10%);\n  animation-name: software-solution-section-title-animation-width-adjust;\n  animation-fill-mode: both;\n  animation-duration: 1s;\n  /* Firefox requires this to apply the animation */\n  animation-timing-function: linear;\n}\n\n#payment-solutions-title {\n  width: 60%;\n  transition: width 1s both;\n  animation-timeline: view(block 60% 10%);\n  animation-name: payment-solution-section-title-animation-width-adjust;\n  animation-fill-mode: both;\n  animation-duration: 1s;\n  /* Firefox requires this to apply the animation */\n  animation-timing-function: linear;\n}\n\n/* KEY FRAMES */\n\n@keyframes tilt-in-from-bottom-right {\n  0% {\n    transform: rotate(70deg) translate(50vw, -50vh);\n    opacity: 0;\n    scale: 1.5;\n  }\n\n  70% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: rotate(0) translate(0, 0);\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n@keyframes snap-in-from-bottom {\n  0% {\n    opacity: 0;\n    line-height: 1.5em;\n  }\n\n  70% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: rotate(0) translate(0, 0);\n    opacity: 1;\n    line-height: 1.25em;\n  }\n}\n\n@keyframes snap-in-from-bottom-paragraph {\n  0% {\n    opacity: 0;\n    line-height: 4.5em;\n  }\n\n  70% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: rotate(0) translate(0, 0);\n    opacity: 1;\n    line-height: 2.5em;\n  }\n}\n\n@keyframes shake {\n  10%,\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n\n  20%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-8px, 0, 0);\n  }\n\n  40%,\n  60% {\n    transform: translate3d(8px, 0, 0);\n  }\n}\n\n@keyframes mobile-operators-section-title-animation-width-adjust {\n  0% {\n    width: 14.5em;\n  }\n\n  100% {\n    width: 7.5em;\n  }\n}\n\n@keyframes enterprise-solution-section-title-animation-width-adjust {\n  0% {\n    width: 35%;\n  }\n\n  100% {\n    width: 20%;\n  }\n}\n\n@keyframes software-solution-section-title-animation-width-adjust {\n  0% {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  100% {\n    margin-left: 1.2em;\n    margin-right: 1em;\n  }\n}\n\n@keyframes payment-solution-section-title-animation-width-adjust {\n  0% {\n    width: 60%;\n  }\n\n  100% {\n    width: 40%;\n  }\n}\n\n/* Media query for animations for Desktop Only */\n@media screen and (min-width: 1800px) {\n}\n\n/* Media query for animations for Laptop only */\n@media screen and (min-width: 1440px) and (max-width: 1800px) {\n}\n\n/* Media query for animations for Tablet only */\n@media screen and (min-width: 960px) and (max-width: 1440px) {\n  @keyframes enterprise-solution-section-title-animation-width-adjust {\n    0% {\n      width: 60%;\n    }\n\n    100% {\n      width: 39.4%;\n    }\n  }\n\n  .software-solution-section-title-animation {\n    width: 50%;\n  }\n\n  @keyframes software-solution-section-title-animation-width-adjust {\n    0% {\n      width: 50%;\n    }\n\n    100% {\n      width: 32%;\n    }\n  }\n\n  #payment-solutions-title {\n    width: 60%;\n  }\n\n  @keyframes payment-solution-section-title-animation-width-adjust {\n    0% {\n      width: 60%;\n    }\n\n    100% {\n      width: 41%;\n    }\n  }\n}\n\n/* Media query for animations for Mobile only */\n@media screen and (min-width: 576px) and (max-width: 960px) {\n  @keyframes enterprise-solution-section-title-animation-width-adjust {\n    0% {\n      width: 80%;\n    }\n\n    100% {\n      width: 49%;\n    }\n  }\n\n  .software-solution-section-title-animation {\n    width: 50%;\n  }\n\n  @keyframes software-solution-section-title-animation-width-adjust {\n    0% {\n      width: 50%;\n    }\n\n    100% {\n      width: 37%;\n    }\n  }\n\n  #payment-solutions-title {\n    width: 80%;\n  }\n\n  @keyframes payment-solution-section-title-animation-width-adjust {\n    0% {\n      width: 80%;\n    }\n\n    100% {\n      width: 44%;\n    }\n  }\n}\n\n/* Media query for animations for Smaller screens */\n@media screen and (max-width: 576px) {\n  @keyframes enterprise-solution-section-title-animation-width-adjust {\n    0% {\n      width: 80%;\n    }\n\n    100% {\n      width: 57.5%;\n    }\n  }\n\n  .software-solution-section-title-animation {\n    width: 80%;\n  }\n\n  @keyframes software-solution-section-title-animation-width-adjust {\n    0% {\n      width: 80%;\n    }\n\n    100% {\n      width: 55%;\n    }\n  }\n\n  #payment-solutions-title {\n    width: 80%;\n  }\n\n  @keyframes payment-solution-section-title-animation-width-adjust {\n    0% {\n      width: 80%;\n    }\n\n    100% {\n      width: 57%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
